import { publicKeyToAddress } from '@neo-one/client-common';
import _ from 'lodash';
export class LedgerHandler {
    constructor(options) {
        this.getAccount = options.getAccount;
        this.byteLimit = options.store.byteLimit;
        this.type = options.store.type;
        this.storePromise = options.store.init();
    }
    async sign(options) {
        const store = await this.storePromise;
        return store.sign(options);
    }
    async scanAccounts(network, maxOffset = 10) {
        const store = await this.storePromise;
        const scanAccountsInternal = async (start, currentOffset = 0) => {
            const ledgerAccounts = await Promise.all(_.range(start, start + maxOffset - currentOffset).map(async (num) => {
                const key = await store.getPublicKey(num);
                return this.publicKeyToLedgerAccount(num, key, network);
            }));
            const unscannedAccounts = await Promise.all(ledgerAccounts.map(async (ledger) => {
                const { balances } = await this.getAccount(network, ledger.userAccount.id.address);
                return {
                    empty: Object.values(balances).every((balance) => balance.isEqualTo(0)),
                    ledger,
                };
            }));
            const { ledgerAccounts: newAccounts, offset: newOffset } = unscannedAccounts.reduce((acc, unscanned) => ({
                ledgerAccounts: acc.ledgerAccounts.concat(unscanned.ledger),
                offset: unscanned.empty ? acc.offset + 1 : 1,
            }), { ledgerAccounts: [], offset: currentOffset });
            if (newOffset < maxOffset) {
                const nextAccounts = await scanAccountsInternal(start + maxOffset - currentOffset, newOffset);
                return newAccounts.concat(nextAccounts);
            }
            return newAccounts;
        };
        const accounts = await scanAccountsInternal(0);
        return accounts.slice(0, accounts.length - (maxOffset - 2));
    }
    async close() {
        const store = await this.storePromise;
        await store.close();
    }
    publicKeyToLedgerAccount(accountVal, publicKey, network) {
        return {
            identifier: accountVal,
            userAccount: {
                id: {
                    network,
                    address: publicKeyToAddress(publicKey),
                },
                name: accountVal.toString(),
                publicKey,
            },
        };
    }
}

//# sourceMappingURL=LedgerHandler.js.map
